module.exports = __webpack_public_path__ + "static/img/mystery-box1.6a03861.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/activity-template/mystery-box1.png
// module id = 9/Bh
// module chunks = 216